import axios from "axios";
import apiClient from "./api-client";
import { type GlobalSettings } from "./types";

const DEFAULT_GLOBAL_SETTINGS: GlobalSettings = {
  minPackageVersion: "1.0.0",
  enablePhysicalDeviceExecutionToggle: false,
};

const getGlobalSettingsQueryKey = (organisationId?: string) =>
  ["globalSettings", organisationId] as const;

const GLOBAL_SETTINGS_TIMEOUT_MS = 5000;

const fetchGlobalSettings = async (): Promise<GlobalSettings> => {
  try {
    const response = await apiClient.get<GlobalSettings>("/global_settings", {
      timeout: GLOBAL_SETTINGS_TIMEOUT_MS,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      throw error;
    }
    return DEFAULT_GLOBAL_SETTINGS;
  }
};

const getGlobalSettingsQueryOptions = (organisationId?: string) => ({
  queryKey: getGlobalSettingsQueryKey(organisationId),
  queryFn: fetchGlobalSettings,
  staleTime: Infinity,
});

export {
  DEFAULT_GLOBAL_SETTINGS,
  fetchGlobalSettings,
  getGlobalSettingsQueryKey,
  getGlobalSettingsQueryOptions,
};
